import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerImageSection: {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    containerImageTitle: {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      padding: "0px 32px",
    },
    ImageVedioTitle: {
      fontSize: "14px",
      fontWeight: 500,
      color: theme.palette.text.tertiary_hover,
      lineHeight: "20px",
    },
    containerImageCards: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "15px",
    },
  };
});
